// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3DL_o","signatureBlock":"Footer_signatureBlock__3PlOv","signature":"Footer_signature__2YWc9"};